import {GitHubAvatar} from '@github-ui/github-avatar'
import type {FC} from 'react'
import {Octicon} from '@primer/react/deprecated'
import {
  EyeIcon,
  PencilIcon,
  PersonIcon,
  PeopleIcon,
  ToolsIcon,
  RepoPushIcon,
  type Icon,
  KeyIcon,
} from '@primer/octicons-react'
import type {BypassActorType} from '../bypass-actors-types'

import styles from './BypassAvatar.module.css'

const roleIconMap: {[key: string]: Icon} = {
  Write: PencilIcon,
  Maintain: ToolsIcon,
  'Repository admin': EyeIcon,
  'Organization admin': EyeIcon,
}

export const BypassAvatar: FC<{
  baseUrl: string
  id: string | number | null
  name: string
  type: BypassActorType
  size?: number
  preferredAvatarUrl?: string
}> = ({baseUrl, id, type, name, size = 16, preferredAvatarUrl}) => {
  if (type === 'Team') {
    return <GitHubAvatar alt={name} src={preferredAvatarUrl || `${baseUrl}/t/${id}`} size={size} />
  }
  if (type === 'Integration') {
    return <GitHubAvatar alt={name} src={preferredAvatarUrl || `${baseUrl}/in/${id}`} size={size} />
  }
  if (type === 'RepositoryRole' || type === 'OrganizationAdmin') {
    return <Octicon icon={roleIconMap[name] || PersonIcon} className={styles.Octicon} />
  }
  if (type === 'DeployKey') {
    return <Octicon icon={KeyIcon} className={styles.Octicon} />
  }
  if (type === 'BusinessTeam') {
    return <Octicon icon={PeopleIcon} className={styles.Octicon} />
  }
  if (type === 'EnterpriseOwner') {
    return <Octicon icon={PeopleIcon} className={styles.Octicon} />
  }
  if (type === 'RepositoryMigration') {
    return <Octicon icon={RepoPushIcon} className={styles.Octicon} />
  }
  if (type === 'EnterpriseRole') {
    return <Octicon icon={PeopleIcon} className={styles.Octicon} />
  }
  return null
}
